function PlanGroupMerchOrgCell(props) {
    return (
        <>{props.value?.product_h2?.map((obj) => obj.label).join(",") ?? "-"}</>
    );
}

export default PlanGroupMerchOrgCell;
